import IDeveloperAccount from "../interfaces/IDeveloperAccount";
import APIService from "./API.service";
const queryString = require("query-string");

class DeveloperAccountService extends APIService {
  // Get the user developer account
  getDeveloperAccount(ownerId: string): Promise<IDeveloperAccount[]> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };

    return this.call.get(
      `${this.apiUrl}/developer_account/${ownerId}?${queryString.stringify(
        query
      )}`
    );
  }

  // Deactive a developer account
  deleteDeveloperAccount(apiKey: string) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.delete(
      `${this.apiUrl}/developer_account/${apiKey}?${queryString.stringify(
        query
      )}`
    );
  }

  // Create a developer account
  createDeveloperAccount(ownerId: string): Promise<IDeveloperAccount> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${this.apiUrl}/developer_account?${queryString.stringify(query)}`,
      JSON.stringify({
        ownerId,
        active: true,
        maxNbrOfCallsPerMonth: 5000,
        numOfCallsThisMonth: 0,
      })
    );
  }

  // Update a developer account
  updateDeveloperAccount(apiKey: string, data: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.put(
      `${this.apiUrl}/developer_account/${apiKey}?${queryString.stringify(
        query
      )}`,
      JSON.stringify(data)
    );
  }
}

export default DeveloperAccountService;
